import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "../axios";
import "./LandingPage.css";

const API_URL = process.env.REACT_APP_API_URL;

const LandingPage = () => {
  const user = JSON.parse(localStorage.getItem("user"));
  const isStaff = user?.is_staff;
  const navigate = useNavigate();
  
  const [hasJananiAccess, setHasJananiAccess] = useState(false);
  const [loading, setLoading] = useState(true);

  console.log("user details", user);

  useEffect(() => {
    const checkJananiAccess = async () => {
      try {
        const token = localStorage.getItem("access_token");
        const response = await axios.get(`${API_URL}api/janani/`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        const jananiData = response.data;
        const isActive = jananiData.length > 0 && jananiData[0].is_active === true;
        
        setHasJananiAccess(isActive);
        localStorage.setItem("janani_active", isActive);
      } catch (error) {
        console.error("Failed to check Janani status:", error);
        setHasJananiAccess(false);
      } finally {
        setLoading(false);
      }
    };

    checkJananiAccess();
  }, []);

  const goTo = (path) => {
    navigate(path, { state: { user } });
  };

  return (
    <div className="landing-page-container">
      {/* ✅ Top 10% - User Welcome Section */}
      <div className="user-welcome-section">
        <div className="welcome-content">
          <h1 className="user-greeting">
            Welcome, <span className="username">{user?.username || "Guest"}</span>
            <span className="wave">👋</span>
          </h1>
          
          <div className="user-info-compact">
            <div className="info-item">
              <span className="info-icon">📧</span>
              <span className="info-text">{user?.email || "N/A"}</span>
            </div>
            
            <div className="info-divider">|</div>
            
            <div className="info-item">
              <span className="info-icon">👤</span>
              <span className="info-text">{isStaff ? "Staff Member" : "User"}</span>
            </div>

            {isStaff && (
              <>
                <div className="info-divider">|</div>
                <div className="status-badge staff-badge">
                  ✅ Staff Access
                </div>
              </>
            )}

            {!loading && hasJananiAccess && (
              <>
                <div className="info-divider">|</div>
                <div className="status-badge janani-badge">
                  💬 Janani AI
                </div>
              </>
            )}
          </div>
        </div>
      </div>

      {/* ✅ Bottom 90% - Navigation Panel */}
      <div className="navigation-section">
        <div className="navigation-grid">
          {/* Janani Button - Featured if Available */}
          {!loading && hasJananiAccess && (
            <button 
              className="nav-card janani-card featured" 
              onClick={() => goTo("/janani-chat")}
            >
              <div className="card-icon">💬</div>
              <div className="card-content">
                <h3 className="card-title">Chat with Janani</h3>
                <p className="card-description">AI-powered assistant</p>
              </div>
              <div className="card-arrow">→</div>
            </button>
          )}

          <button className="nav-card" onClick={() => goTo("/income-tax-password")}>
            <div className="card-icon">🔐</div>
            <div className="card-content">
              <h3 className="card-title">Income Tax Password</h3>
              <p className="card-description">Manage tax credentials</p>
            </div>
            <div className="card-arrow">→</div>
          </button>

          <button className="nav-card" onClick={() => goTo("/gst-password")}>
            <div className="card-icon">🔑</div>
            <div className="card-content">
              <h3 className="card-title">GST Password</h3>
              <p className="card-description">Manage GST credentials</p>
            </div>
            <div className="card-arrow">→</div>
          </button>

          <button className="nav-card" onClick={() => goTo("/income-tax-filingstatus")}>
            <div className="card-icon">📊</div>
            <div className="card-content">
              <h3 className="card-title">Income Tax Status</h3>
              <p className="card-description">View filing status</p>
            </div>
            <div className="card-arrow">→</div>
          </button>

          <button className="nav-card" onClick={() => goTo("/gst-filingstatus")}>
            <div className="card-icon">📈</div>
            <div className="card-content">
              <h3 className="card-title">GST Filing Status</h3>
              <p className="card-description">Track GST filings</p>
            </div>
            <div className="card-arrow">→</div>
          </button>

          <button className="nav-card" onClick={() => goTo("/gst-summary")}>
            <div className="card-icon">📈</div>
            <div className="card-content">
                <h3 className="card-title">GST Summary</h3>
                <p className="card-description">Track GST Summary </p>
            </div>
            <div className="card-arrow">→</div>
          </button>

          {isStaff && (
            <button className="nav-card staff-card" onClick={() => goTo("/website-management")}>
              <div className="card-icon">🌐</div>
              <div className="card-content">
                <h3 className="card-title">Website Management</h3>
                <p className="card-description">Admin portal</p>
              </div>
              <div className="card-arrow">→</div>
            </button>
          )}

          {isStaff && (
            <button className="nav-card staff-card" onClick={() => goTo("/staff-management")}>
              <div className="card-icon">👥</div>
              <div className="card-content">
                <h3 className="card-title">Staff Management</h3>
                <p className="card-description">Manage team</p>
              </div>
              <div className="card-arrow">→</div>
            </button>
          )}
          {isStaff && (
            <button className="nav-card staff-card" onClick={() => goTo("/attendance-sheet")}>
              <div className="card-icon">👥</div>
              <div className="card-content">
                <h3 className="card-title">Attendance Sheet</h3>
                
                <p className="card-description">Attendance Track</p>
              </div>
              <div className="card-arrow">→</div>
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default LandingPage;